import React from "react";
import APP_ENV from "../../Environment";
import * as PropTypes from "prop-types";

export class RakutenConnect extends React.Component {
    render() {
        const open_id_connect_url = `${APP_ENV.USERPOOLDOMEIN}/oauth2/authorize?identity_provider=Rakuten&redirect_uri=${APP_ENV.FRONT_URL}/connect_oauth&response_type=code&client_id=${APP_ENV.USERPOOLWEBCLIENTID_FOR_OIDCSIGNUP}&scope=openid+profile+aws.cognito.signin.user.admin`;
        let display_component = null;
        if (this.props.action_type === 'connect_oauth' || this.props.action_type === 'connected_oauth') {
            display_component =
                <div className="text-center main_login_form">
                    <div className="main_login_box_rakuten">
                        <div className="main_login_box-body">
                            <p className="login_btn_box rakuten">
                                <button
                                    className="btn btn--login rakuten"
                                    onClick={() => { (this.props.handleDeleteOauth()); }}
                                >
                                    楽天ID連携を解除する
                                </button>

                            </p>
                            <p className="login_btn_box rakuten">
                                <button
                                    className="btn btn--login rakuten"
                                    onClick={() => { (this.props.handlePutOauth()); }}
                                >
                                    研究参加への同意のみを解除する
                                </button>
                            </p>
                        </div>
                    </div>
                </div>

        } else if (this.props.action_type === 'unconnect_oauth_only_research_permit') {
            display_component =
                <div className="text-center main_login_form">
                    <div className="main_login_box_rakuten">
                        <div className="main_login_box-body">
                            <p className="login_btn_box rakuten">
                                <button
                                    className="btn btn--login rakuten"
                                    onClick={() => { (this.props.handleDeleteOauth()); }}
                                >
                                    楽天ID連携を解除する
                                </button>

                            </p>
                        </div>
                    </div>
                </div>

        } else {
            display_component =
                <div className="text-center main_login_form">
                    <div className="main_login_box_rakuten">
                        <div className="main_login_box-body">
                            <p className="login_btn_box rakuten">
                                <a href={open_id_connect_url} className="btn btn--login rakuten">楽天IDログイン連携</a>
                            </p>
                        </div>
                    </div>
                </div>

        }

        return display_component
    }
}

RakutenConnect.propTypes = {
    action_type: PropTypes.string,
    handlePutOauth: PropTypes.func,
    handleDeleteOauth: PropTypes.func,
};


export default RakutenConnect;